const currencies: Currency[] = ['USD', 'CAD', 'EUR', 'GBP', 'AUD', 'HKD']

export interface CurrencyName {
  name: string
  value: Currency
}

export const currencyNames: CurrencyName[] = [
  {
    name: 'United States Dollar - $',
    value: 'USD',
  },
  {
    name: 'Canadian Dollar - $',
    value: 'CAD',
  },
  {
    name: 'Euro - €',
    value: 'EUR',
  },
  {
    name: 'Pound Sterling - £',
    value: 'GBP',
  },
  {
    name: 'Australian Dollar - $',
    value: 'AUD',
  },
  {
    name: 'Hong Kong Dollar - $',
    value: 'HKD',
  },
]

export interface CurrencyLabel {
  label: string
  value: Currency
}

export const currencyLabels: CurrencyLabel[] = currencyNames.map(
  ({ name, value }): CurrencyLabel => ({
    label: name,
    value: value,
  }),
)

export default currencies
